import useScrollAnimation from './useScrollAnimation'
import { Container, Grid, Box, Typography } from '@mui/material'

const RealTimeSolutions = () => {
  useScrollAnimation('.real-time-solutions')

  return (
    <section className="real-time-solutions  pad-60">
      <Container>
        <Grid container alignItems="center">
          {/* Left Side Image */}
          <Grid item lg={7} md={7} sm={7} xs={12} className="left-image">
            <Box
              component="img"
              src="/assets/document-templates/offer.png"
              alt="Business Growth"
              className="img-fluid "
            />
          </Grid>

          {/* Right Side Content */}
          <Grid className="pdlft40" item lg={5} md={5} sm={5} xs={12}>
            <Typography variant="h2" className="mb-4 main_titel">
              We Offer Real-time Business <span> Grow Solutions</span>
            </Typography>
            <Box className=" mb-3">
              <Typography variant="body1">
                We guide our partner/client every step of the way, from onboarding to continuous
                support. We assist your club in digitizing its platform, standardizing workflows,
                and optimizing analytics. Additionally, we offer tailored consulting on best
                practices to address both short-term challenges and long-term issues, ensuring
                sustainable and effective solutions.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default RealTimeSolutions
